import { render, staticRenderFns } from "./contentHelp.vue?vue&type=template&id=68d08861&"
import script from "./contentHelp.vue?vue&type=script&lang=js&"
export * from "./contentHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports